<!-- 注册协议 -->
<template>
  <div class="page-box">
    <div class="title">欢迎使用中交智运物流平台</div>
    <div class="intro">欢迎您注册成为本平台用户,注册前请仔细阅读本协议:</div>
    <AgreementContent :resigister="true"></AgreementContent>
  </div>
</template>

<script>
import AgreementContent from "../components/Agreement-content.vue";
export default {
  data() {
    return {};
  },

  components: {
    AgreementContent,
  },

  computed: {},

  mounted() {},

  methods: {},
};
</script>
<style lang='scss' scoped>
.title {
  font-size: 18px;
  font-weight: 600;

  margin-top: 10px;
  margin-bottom: 14px;

  text-align: center;

  color: #222;
}

.intro {
  font-size: 14px;
  font-weight: bold;
  line-height: 20px;

  margin-bottom: 16px;

  color: #222;
  span {
    font-weight: 600;
  }
}
</style>